import OrderTable from "../components/module/admin/OrderTable";
import AdminFilter from "../components/module/admin/AdminFilter";
import {SweetModal} from 'sweet-modal-vue'
import LpModal from '../components/module/common/LpModal.vue'
import AdminSimpleTable from '../components/module/admin/AdminSimpleTable';
import Structure from '../helper/structure-mart'
import moment from 'moment';

export default {

  components: {
    AdminFilter,
    OrderTable,
    SweetModal,
    LpModal,
    AdminSimpleTable
  },

  created() {
    // tableData, filter_list 초기화
    this.getPartnerSimple();
  },

  data() {
    return {
      isLoadPage: false,
      tableData: [],
      filterData: [],
      filtered: {},
      filter_list: [],
      allCount: 0,
      filteredCount: 0,
      tableItems: [],
      structure_path:'',
      post_url:'',
      // 체크리스트
      checkArr: [],
      // 요청할 상태
      status: 0,
      // 변경할 상태값 목록
      status_arr: [],
      // 현재 탭
      selectedTab: 1,      // 0: 주문번호별, 1: 주문상품 번호별
      selectedValue: {
        selected: [],
        status: 0
      },
      totalPrice: 0,
      partners: []
    }
  },
  watch: {
    modalStatus(n) {
      if(n==='close' && this.post_url){
        this.getData(this.post_url);
      }
    }
  },
  computed: {
    path() {
      if (this.$store.getters.mode==='admin'){
        return this.$route.path.replace('/office/admin/','');
      }
      else if (this.$store.getters.mode==='partner'){
        return this.$route.path.replace('/office/partner/','');
      }
    }
  },

  methods: {
    routerProduct(product) {
      let product_id = 0
      if (this.$store.getters.mode === 'partner') {
        product_id = product.id;
      } else {
        product_id = product.parent;
      }
      if (product_id > 0) this.$router.push(this.getPath(`product/create?id=${product_id}`));
    },
    // 체크박스 일괄 선택
    clickCheckBox(res) {
      if(res===true) {
        this.checkArr.forEach(item=> {
          item.value=true;
        })
      }
      else {
        this.checkArr.forEach(item=> {
          item.value=false;
        })
      }
    },
    // structre_path : 필터 데이터, 테이블 데이터
    // post_url : axios 호출할 post url
    initializing(structure_path, post_url, current_page) {
      this.structure_path = structure_path;
      this.post_url = post_url;
      this.setStructure(structure_path);
      this.initFiltered();
      this.getData();
      if(current_page) this.getStatusList(current_page);
    },
    setStructure(structure_path) {
      // structure.js 에서 경로에 맞는 데이터를 온다.
      this.filterData = Structure[structure_path+'_filter_data'];
      this.tableData = Structure[structure_path+'_table_data'];

      if(this.filterData) {
        let item = find(this.filterData, 'key', 'hope_day');
        if(item) {
          item.start = {
            key: 'hope_day_start',
            value: ''
          }
          item.end = {
            key: 'hope_day_end',
            value: ''
          }
        }
        if(this.$store.getters.mode==='partner') {
          let idx = this.filterData.findIndex(item => item.type === 'partner');
          removeIndex(this.filterData, idx)
        }
      }
    },
    initFiltered() {
      this.filtered = {
        cur_page: 1,
        page_num:1,
        total_page:1,
        page_length: 10
      };
      if(this.$refs.orderTable) {
        this.$refs.orderTable.page_length = 10;
      }
      // if(!this.isLoadPage) {
      //   let today = moment().format('YYYY-MM-DD');
      //   this.filtered.start = today;
      //   this.filtered.end = today;
      //   this.isLoadPage = true;
      // }
      if(this.$route.path.indexOf('mart/order/statistics/week')>-1) {
        this.filtered.week = 7;
      }
      else if(this.$route.path.indexOf('mart/order/statistics/month')>-1) {
        this.filtered.start = moment().subtract(3, 'months').format('YYYY-MM');
        this.filtered.end = moment().format('YYYY-MM');
      }
      else if(this.$route.path.indexOf('mart/order/statistics/product')>-1) {
        this.filtered.start = moment().subtract(1, 'week').format('YYYY-MM-DD');
        this.filtered.end = moment().format('YYYY-MM-DD');
      }
      else {
        this.initSelectedDate();
      }
      // this.filtered.hope_day_start = moment('2017-01-01 00:00').format('YYYY-MM-DD HH:mm');
      // this.filtered.hope_day_end = moment(moment().format('YYYY-MM-DD')+' 23:50').format('YYYY-MM-DD HH:mm')
    },

    initSelectedDate() {
      let today = moment().format('YYYY-MM-DD');
      let path = this.$route.path;
      if(path.indexOf('mart/order_list_order')>-1) {
        this.filtered.dt_100_start = today;
        this.filtered.dt_100_end = today;
      } else if(path.indexOf('mart/order_list_pay_new')>-1) {
        /*this.filtered.hope_day_start = today;
        this.filterData[1].start.value = today;*/
        this.filtered.hope_day_start = undefined;
        this.filterData[1].start.value = undefined;
      } else if(path.indexOf('mart/order_list_goods_all')>-1) {
        this.filtered.dt_200_start = today;
        this.filtered.dt_200_end = today;
      } else if(path.indexOf('mart/order_list_delivery_new')>-1) {
        this.filtered.dt_300_start = today;
        this.filtered.dt_300_end = today;
      } else if(path.indexOf('mart/order_list_deliverying')>-1) {
        this.filtered.dt_301_start = today;
        this.filtered.dt_301_end = today;
      } else if(path.indexOf('mart/order_list_delivery_success')>-1) {
        this.filtered.dt_302_start = today;
        this.filtered.dt_302_end = today;
      } else if(path.indexOf('mart/order_list_settle')>-1) {
        this.filtered.dt_400_start = today;
        this.filtered.dt_400_end = today;
      } else if(path.indexOf('mart/order_list_cancel_new')>-1) {
        this.filtered.dt_500_start = today;
        this.filtered.dt_500_end = today;
      } else {
        this.filtered.start = today;
        this.filtered.end = today;
      }
    },

    // 내역 가져오기
    getData() {
      if(!this.post_url) return;

      this.tableItems = [];
      if(this.filtered.hope_day_start && this.filtered.hope_day_start.indexOf('00:00')===-1) {
        this.filtered.hope_day_start += ' 00:00'
      }
      if(this.filtered.hope_day_end && this.filtered.hope_day_end.indexOf('23:59')===-1) {
        this.filtered.hope_day_end += ' 23:59'
      }
      // this.$store.commit('setLoading', true);
      this.$axios.get(this.getUrl(this.post_url), {
        params: this.filtered
      })
        .then(res => {
          if ( res.status === 200 ) {
            if ( res.data.data === undefined )
              this.tableItems = res.data;
            else
              this.tableItems = res.data.data;

            this.filtered.page_length = res.data.page_length;
            this.filtered.cur_page = res.data.cur_page;
            this.filtered.total_page = res.data.total_page;
            this.allCount = res.data.total_count;
            this.filteredCount = res.data.count;

            // 주문번호 탭
            if(this.selectedTab===0) {
              /*let tableList = [];
              for(let i = 0; i < this.tableItems.length; i++) {
                tableList.push({id: this.tableItems[i].order_id, value: false });
              }
              this.checkArr = tableList;*/
              //let ids = Array.from(new Set(this.tableItems.map(i => i.id)));
              this.checkArr = this.tableItems.map(i => { return {id: i.id, value: false} });
            }
            // 상품 주문번호 탭
            else if(this.selectedTab===1) {

              // 체크리스트 추가
              /*let tableList = [];
              for (let i = 0; i < this.tableItems.length; i++) {
                tableList.push({id: this.tableItems[i].id, value: false});
              }
              this.checkArr = tableList;
              */
              //let ids = Array.from(new Set(this.tableItems.map(i => i.order_id)));
              this.checkArr = this.tableItems.map(i => { return {id: i.order_id, value: false} });
            }

            /* 테이블에 재조합 rowspan 추가 */
            this.initDeliveryTable();
            // this.$store.commit('setLoading', false);

            // 전체 주문 신청 내역
            if(this.$route.path.indexOf('mart/order_list_pay_all')>-1) {
              this.getTotalPrice();
            }
          }
        }).catch(res => {
      });
    },

    // delivery package
    // 주문의 주문자, 배달비, 할인금액, 포인트등 order_id 주문 번호가 같을 경우 테이블 row 합쳐서 보여줌
    initDeliveryTable() {
      if(this.selectedTab===0) {
        return;
      }
      this.tableItems.forEach(item=> {
        item.rowspan = 0;
      })
      for(let i=0; i<this.tableItems.length; i++) {
        this.tableItems[i].rowspan = 1;
        let j = 0;
        for(j=i+1; j<this.tableItems.length; j++) {
          // 주문 번호가 같을 경우
          if(this.tableItems[i].order_id === this.tableItems[j].order_id) {
            this.tableItems[i].rowspan += 1;
          }
          // 주문 번호가 다를 경우
          else {
            break;
          }
        }
        i = j-1;
      }
    },

    selPageLength(length) {
      this.filtered.page_length = length;
      this.filtered.page_num = 1;
      this.getData();
    },

    ordering(res){
      this.filtered.ordering=res;
      this.getData();
    },

    // 상세페이지
    clickDetail(id){
      this.$router.push(this.getPath(`mart/order/detail?id=${id}`));
    },

    // 상태값 목록
    getStatusList(current_page){
      this.$axios.get(this.getUrl(`mart/order/status?page=${current_page}`)).then(res=>{
        if(res.status === 200){
          this.status_arr = res.data;
        }
      })
    },

    // 결제 상태
    payStatus(status){
      if(status>=101) return '결제완료';
      else return '미결제'
    },

    // 주문 상태
    // convertStatusType(st){
    //   return Const['ko_purchase'][st]
    // },

    convertPayType(name){
      let value = '';
      switch(name) {
        case 'credit':
          value='신용카드';
          break;
        case 'phone':
          value='휴대폰';
          break;
        case 'vbank':
          value='무통장';
          break;
        case 'trans':
          value='실시간 계좌이체';
          break;
      }
      return value;
    },
    getStatusName(status) {
      switch (status) {
        case 100:
          return '입금대기'
        case 101:
          return '입금완료'
        case 102:
          return '주문확정'
        case 200:
          return '상품준비중'
        case 300:
          return '배달대기'
        case 301:
          return '배달중'
        case 302:
          return '배달완료'
        case 400:
          return '구매확정'
        case 500:
          return '취소요청(승인대기)'
        case 501:
          return '취소승인(환불대기)'
        case 502:
          return '취소보류'
        case 503:
          return '취소완료(입금전 주문취소)'
        case 504:
          return '취소완료(환불 완료)'
        case 505:
          return '취소요청철회'
        case 600:
          return '교환요청(승인대기)'
        case 601:
          return '교환처리중(수거진행)'
        case 602:
          return '교환검사중'
        case 603:
          return '교환검사완료(교환대기)'
        case 604:
          return '교환검사완료(교환보류)'
        case 605:
          return '교환상품준비중'
        case 606:
          return '교환상품배달대기'
        case 607:
          return '교환배달중'
        case 608:
          return '교환배달완료'
        case 609:
          return '교환구매확정'
        case 610:
          return '교환요청철회'
        case 700:
          return '반품요청(승인대기)'
        case 701:
          return '반품처리중(수거진행)'
        case 702:
          return '반품검사중'
        case 703:
          return '반품검사완료(환불대기)'
        case 704:
          return '반품검사완료(환불보류)'
        case 705:
          return '반품완료(환불완료)'
        case 706:
          return '반품요청철회'
        case '입금대기':
          return 100
        case '입금완료':
          return 101
        case '주문확정':
          return 102
        case '상품준비중':
          return 200
        case '배달대기':
          return 300
        case '배달중':
          return 301
        case '배달완료':
          return 302
        case '구매확정':
          return 400
        case '취소요청(승인대기)':
          return 500
        case '취소승인(환불대기)':
          return 501
        case '취소보류':
          return 502
        case '취소완료(입금전 주문취소)':
          return 503
        case '취소완료(환불 완료)':
          return 504
        case '취소요청철회':
          return 505
        case '교환요청(승인대기)':
          return 600
        case '교환처리중(수거진행)':
          return 601
        case '교환검사중':
          return 602
        case '교환검사완료(교환대기)':
          return 603
        case '교환검사완료(교환보류)':
          return 604
        case '교환상품준비중':
          return 605
        case '교환상품배달대기':
          return 606
        case '교환배달중':
          return 607
        case '교환배달완료':
          return 608
        case '교환구매확정':
          return 609
        case '교환요청철회':
          return 610
        case '반품요청(승인대기)':
          return 700
        case '반품처리중(수거진행)':
          return 701
        case '반품검사중':
          return 702
        case '반품검사완료(환불대기)':
          return 703
        case '반품검사완료(환불보류)':
          return 704
        case '반품완료(환불완료)':
          return 705
        case '반품요청철회':
          return 706
      }
    },
    // 단일 상태 변경 모달 열기
    openStatusChangeModal(id, modal_name) {
      this.selectedValue = {
        selected: [id],
        status: this.getStatusName(modal_name)
      };
      this.$modal.show(modal_name);
    },
    // 모달 닫기
    closeModal(modal_name) {
      this.$modal.hide(modal_name);
    },
    // 주문 상태변경시
    confirmStatusChange (modal_name) {
      let id_list = this.selectedValue.selected;
      if(id_list.length===0) return;
      let url = 'mart/order/status/change/multiple';
      if(this.$route.path.indexOf('order/detail')>-1) {
        url = 'mart/orderproduct/status/change/multiple';
      }
      // if(this.selectedTab===0) url = 'mart/order/status/change/multiple';
      // else if(this.selectedTab===1) url = 'mart/orderproduct/status/change/multiple';
      this.$axios.post(this.getUrl(url), {
        status: this.selectedValue.status,
        checked: id_list
      }).then(res => {
        if(res.status===200){
          // this.toast('처리가 완료되었습니다.');
          if(this.$route.query.id) {
            this.getDetail();
            this.$modal.show(modal_name+'-Success');
          }
          else {
            this.getData();
            this.$modal.show(modal_name+'-Success');
          }
        }
      }).catch(error => {
        if (error.response.status === 400) {
          if(error.response.data.message) {
            this.toast(error.response.data.message)
          }
          else {
            this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
          }
        } else {
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        }
      });
    },
    // 체크박스 선택 후 일괄 변경시
    saveData (modal_name) {
      let id_list = this.getCheckedArr();
      if(id_list.length===0) return;

      let url = '';
      if(this.selectedTab===0) url = 'mart/order/status/change/multiple';
      else if(this.selectedTab===1) url = 'mart/orderproduct/status/change/multiple';
      this.$axios.post(this.getUrl(url),{
        status: this.status,
        checked: id_list
      }).then(res=>{
        if(res.status===200){
          this.toast('처리가 완료되었습니다.');
          if(this.$route.query.id) {
            this.getDetail();
          }
          else {
            this.getData();
          }
          if(modal_name) this.$modal.hide(modal_name);
        }
      })
    },

    // 일괄 상태 변경
    clickChange(){
      this.status = parseInt(this.status);
      let id_list = this.getCheckedArr();
      if(id_list.length===0) return;
      this.selectedValue = {
        selected: id_list,
        status: this.status
      };

      // console.log(this.getStatusName(this.status))
      this.$modal.show(this.getStatusName(this.status));

      // // 취소요청, 취소완료시 모달 띄워서 확인하기
      // if(this.status===504) {
      //   this.openModal('cancelModal');
      // }
      // // 취소 요청 철회
      // else if(this.status===505) {
      //   this.openModal('cancelModal');
      // }
      // // 교환요청 철회
      // else if(this.status===610) {
      //   this.openModal('cancelExchangeModal')
      // }
      // // 반품 완료
      // else if(this.status===705) {
      //   this.openModal('refundModal');
      // }
      // // 반품 철회
      // else if(this.status===706) {
      //   this.openModal('cancelRefundModal');
      // }
      // else this.saveData();
    },

    // 모달 확인시
    confirmModal(modal_name){
      this.saveData(modal_name);
    },

    // 단일 상태 변경
    statusChange(id, status) {
      let url = 'mart/orderproduct/status/change';
      this.$axios.post(this.getUrl(url), {
        id: id,
        status: status
      }).then(res=> {
        if(res.status===200) {
          this.toast('상태가 변경되었습니다.');
          if(this.$route.query.id) {
            this.getDetail();
          }
          else {
            this.getData();
          }
        }
      })
    },

    //  체크된 id들 가져오기
    getCheckedArr(){
      let result = [];
      for(let id of Array.from(new Set(this.checkArr.map(i => i.id)))) {
        result.push(this.checkArr.filter(i => i.id === id)[0]);
      }
      return result.filter(i => i.value).map(i => i.id);

      /*let id_list = [];
      for(let i=0; i<this.checkArr.length; i++){
        if(this.checkArr[i].value){
          id_list.push(this.checkArr[i].id);
        }
      }

      return id_list;*/
    },

    openModal (modal_name) {
      let id_list = this.getCheckedArr();
      if(id_list.length===0) return;
      this.$modal.show(modal_name);
    },

    autoHyphenPhone(str) {
      str = str.replace(/[^0-9]/g, '');
      var tmp = '';

      if (str.substr(0, 2) == '02') {
        if (str.length < 3) {
          return str;
        } else if (str.length < 6) {
          tmp += str.substr(0, 2);
          tmp += '-';
          tmp += str.substr(2);
          return tmp;
        } else if (str.length < 10) {
          tmp += str.substr(0, 2);
          tmp += '-';
          tmp += str.substr(2, 3);
          tmp += '-';
          tmp += str.substr(5);
          return tmp;
        } else {
          tmp += str.substr(0, 2);
          tmp += '-';
          tmp += str.substr(2, 4);
          tmp += '-';
          tmp += str.substr(6);
          return tmp;
        }
      }
      else {
        if (str.length < 4) {
          return str;
        } else if (str.length < 7) {
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3);
          return tmp;
        } else if (str.length < 11) {
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3, 3);
          tmp += '-';
          tmp += str.substr(6);
          return tmp;
        } else {
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3, 4);
          tmp += '-';
          tmp += str.substr(7);
          return tmp;
        }
      }
      return str;
    },
    optionFullName(option) {
      return `${option.option.name}: +${option.option.price}원 / ${option.quantity}개`;
    },
    getTotalPrice () {
      this.$axios.get(this.getUrl('mart/order/total'), {
        params: this.filtered
      }).then(res => {
        if(res.status===200) {
          this.totalPrice = res.data.total;
        }
      })
    },
    getPartnerSimple () {
      if(this.$store.getters.mode==='admin' || this.$store.getters.mode==='supervisor') {
        this.$axios.get(this.getUrl('partner/simple')).then(res => {
          this.partners = res.data;
        })
      }
    },
    selectPartner (res) {
      this.filtered.partner_id = res.value;
      this.getData();
    },
    orderDownloadFile(query) {
      let query_filter = '';
      if(query) {
        query_filter = query
      }
      this.$axios.get(this.getUrl(`mart/order/xlsx${query_filter}`), {
        params: this.filtered,
        responseType: 'arraybuffer',
      }).then(response=> {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let blobURL = window.URL.createObjectURL(blob);
        let tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', 'order.xlsx');
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
      })
    }
  }
}
